import React, { useState, useEffect } from 'react';
import { Breadcrumb, Collapse, Switch } from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import {
  Form,
  Input,
  Button,
  Space,
  Skeleton,
  ConfigProvider,
  BackTop,
} from 'antd';
import { FieldData } from 'rc-field-form/lib/interface';
import { useHistory } from 'react-router-dom';
import plPL from 'antd/lib/locale/pl_PL';
import TextEditor from 'modules/layoutModule/components/TextEditor/TextEditor';
import 'moment/locale/pl';
import FormCoverUpload from 'modules/galleryModules/components/FormCoverUpload';
import 'dayjs/locale/pl';
import {
  getSpecificGtwRequirementRequest,
  saveGtwRequirementRequest,
} from '../requests/gtwRequests';

const GtwRequirementsEdit = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [fields, setFields] = useState<FieldData[]>([]);
  const [loading, toggleLoading] = useState<boolean>(false);
  const history = useHistory();
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [contentValue, setContentValue] = useState<string | undefined>('');
  const [cover, setCover] = useState<string | null>(null);
  const [coverChanged, changeCover] = useState<boolean>(false);

  useEffect(() => {
    toggleLoading(true);
    getSpecificGtwRequirementRequest(id)
      .then((response) => {
        if (response) {
          toggleLoading(false);
          const { data } = response;

          setFields([
            {
              name: ['id'],
              value: data.id,
            },
            {
              name: ['title'],
              value: data.title,
            },
            {
              name: ['content1'],
              value: data.content1,
            },
            {
              name: ['fileImage1'],
              value: data.fileImage1,
            },
            {
              name: ['isActive'],
              value: data.isActive,
            },
          ]);
          setContentValue(data.content1);
          form.setFieldsValue({
            fileImage1: data?.fileImage1,
          });
          setCover(data?.fileImage1);
        } else {
          history.push('/gtw-requirements');
        }
      })
      .catch(() => {
        history.push('/gtw-requirements');
      });
  }, []);

  const onFinish = (values: any) => {
    toggleButtonLoading(true);
    saveGtwRequirementRequest(values).then(() => {
      toggleButtonLoading(false);
    });
  };

  const onContentEdit = (e: any) => {
    setFields([
      {
        name: ['content1'],
        value: e,
      },
    ]);
  };

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const updateCover = (value: string | null) => {
    form.setFieldsValue({
      fileImage1: value,
    });
    setCover(value);
    changeCover(true);
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Grunt to Wiedza</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/gtw-requirements">Edycje warunki</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/gtw-requirements/${id}`}>Edycja wpisu</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <div className="site-layout-background">
          {loading && <Skeleton active />}
          {!loading && (
            <Form
              layout="vertical"
              fields={fields}
              onFinish={onFinish}
              form={form}
              validateMessages={validateMessages}
            >
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name="fileImage1"
                label="Piktogram"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={cover}
                  setCover={updateCover}
                  isNew={coverChanged}
                  id={form.getFieldsValue()?.id}
                  field="fileImage1"
                  number={1}
                  asPng
                  hideTags
                />
              </Form.Item>

              <Form.Item
                name="title"
                label="Tytuł"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="content1"
                label="Treść"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <TextEditor
                  initialValue={contentValue}
                  onChange={onContentEdit}
                  disableGallery
                />
              </Form.Item>
              <Form.Item
                name="isActive"
                label="Aktywność"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
              <Form.Item>
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                    loading={isSaveButtonLoading}
                  >
                    Zapisz
                  </Button>
                  <Link to="/gtw-requirements">
                    <Button>Powrót</Button>
                  </Link>
                </Space>
              </Form.Item>
            </Form>
          )}
          {loading && (
            <Link to="/gtw-requirements">
              <Button>Powrót</Button>
            </Link>
          )}
          <BackTop />
        </div>
      </ConfigProvider>
    </>
  );
};

export default GtwRequirementsEdit;
